module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.portType == "Sea_Port" ?
    " Gate-In at Terminal By Road" :
    "Handover & Rail Out") + "\n          (" + _vm._s(_vm.handover.ccType) + ")")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(
    _vm.railoutMain.ffRailOutId != '' ||
    (_vm.handover.handoverToRailId != '' &&
      _vm.handover.handoverTo == 'HandOverToPort')
  ) ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.proceedInv
    }
  }, [_vm._v("Proceed To Invoice")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.mainEntryData[0].allModuleId ? this.mainEntryData[0].allModuleId : '',
      "jobSeriesBanner": this.mainEntryData[0].ccImportSeries ?
        this.mainEntryData[0].ccImportSeries :
        '',
      "bannerClientName": this.mainEntryData[0].Exporter ? this.mainEntryData[0].Exporter : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.portType != 'Sea_Port') ? _c('div', {
    staticClass: "phone-viewport",
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle",
    class: _vm.handover.handoverToRailId == '' ||
      _vm.handover.handoverTo == 'HandOverToPort' ?
      'md-active' :
      '',
    staticStyle: {
      "background": "darkcyan !important"
    },
    attrs: {
      "id": "showVisibility"
    },
    on: {
      "click": _vm.showOverflow
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Handover")]), _vm._v(" "), _c('md-list-expand', [_c('b-card', [_c('md-list', [(_vm.handover.editedBy != null && _vm.handover.editedBy != '') ? _c('b-alert', {
    staticClass: "gutr",
    attrs: {
      "id": "1",
      "show": "",
      "dismissible": ""
    }
  }, [_vm._v("Last Updated by\n                        " + _vm._s(_vm.handover.editedBy != null && _vm.handover.editedBy != "" ?
    _vm.handover.editedBy :
    _vm.handover.AddedBy) + "\n                        on\n                        " + _vm._s(_vm.handover.updateTime == null && _vm.handover.updateTime == "" ?
    _vm.handover.loginTime :
    _vm.handover.updateTime))]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Handover Party *")])], 1), _vm._v(" "), (!_vm.handover.handoverTo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.handoverTo))]) : _vm._e()])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted",
      "name": "permitted1",
      "md-value": "HandOverToIcd",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.handoverTo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverTo", $$v)
      },
      expression: "handover.handoverTo"
    }
  }, [_vm._v("HandOver To ICD")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "HandOverToCFS",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.handoverTo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverTo", $$v)
      },
      expression: "handover.handoverTo"
    }
  }, [_vm._v("HandOver To CFS")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted3",
      "name": "permitted3",
      "md-value": "HandOverToPort",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.handoverTo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverTo", $$v)
      },
      expression: "handover.handoverTo"
    }
  }, [_vm._v("HandOver To PORT")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("LEO Date")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-flex-small": "100"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.leoDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "leoDate", $$v)
      },
      expression: "handover.leoDate"
    }
  }), _vm._v(" "), (!_vm.handover.leoDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.leoDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("Handover Date")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-flex-small": "100"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.handoverDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "handoverDate", $$v)
      },
      expression: "handover.handoverDate"
    }
  }), _vm._v(" "), (!_vm.handover.handoverDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.handoverDate))]) : _vm._e(), _vm._v(" "), (!_vm.handover.handoverDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.handoverDate))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBillNo",
      "name": "shippingBillNo",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.ccSealNo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "ccSealNo", $$v)
      },
      expression: "handover.ccSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.handover.handoverTo == 'HandOverToCFS') ? _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("CFS Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cfsList,
      "id": "cfs",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select CFS"
    },
    model: {
      value: (_vm.handover.cfsId),
      callback: function($$v) {
        _vm.$set(_vm.handover, "cfsId", $$v)
      },
      expression: "handover.cfsId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.handover.handoverTo == 'HandOverToCFS') ? _c('div', _vm._l((_vm.containerTypeMaster), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "labelMargtop",
      attrs: {
        "gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "40",
        "md-flex-small": "100"
      }
    }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "value": item.containerType,
        "disabled": ""
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "55",
        "md-flex-small": "100"
      }
    }, [_c('label', [_vm._v("Container Incentive")]), _vm._v(" "), _c('b-input', {
      attrs: {
        "id": "containerIncentive",
        "name": "containerIncentive"
      },
      model: {
        value: (_vm.containerIncentive[index]),
        callback: function($$v) {
          _vm.$set(_vm.containerIncentive, index, $$v)
        },
        expression: "containerIncentive[index]"
      }
    })], 1)], 1)
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("TR Status")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted",
      "name": "permitted1",
      "md-value": "1",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.trStatus),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trStatus", $$v)
      },
      expression: "handover.trStatus"
    }
  }, [_vm._v("Handover to Surveyor")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted2",
      "name": "permitted2",
      "md-value": "2",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.trStatus),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trStatus", $$v)
      },
      expression: "handover.trStatus"
    }
  }, [_vm._v("Courier POL")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted3",
      "name": "permitted3",
      "md-value": "3",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.trStatus),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trStatus", $$v)
      },
      expression: "handover.trStatus"
    }
  }, [_vm._v("Handover to Line")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "permitted3",
      "name": "permitted3",
      "md-value": "4",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.trStatus),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trStatus", $$v)
      },
      expression: "handover.trStatus"
    }
  }, [_vm._v("Courier to Pridel office")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("TR")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "TR",
      "name": "TR",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.trDetail),
      callback: function($$v) {
        _vm.$set(_vm.handover, "trDetail", $$v)
      },
      expression: "handover.trDetail"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("Courier Name")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "TR",
      "name": "TR",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.courierName),
      callback: function($$v) {
        _vm.$set(_vm.handover, "courierName", $$v)
      },
      expression: "handover.courierName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.railOutPridel == 'Pridel') ? _c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('div', {
    attrs: {
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Payment Details")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBillNo",
      "name": "shippingBillNo",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.shippingBillNo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "shippingBillNo", $$v)
      },
      expression: "handover.shippingBillNo"
    }
  })], 1), _vm._v(" "), (!_vm.handover.shippingBillNo && _vm.isPridel == 'Pridel') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.shippingBillNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Receipt No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "receiptNo",
      "name": "receiptNo",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.receiptNo),
      callback: function($$v) {
        _vm.$set(_vm.handover, "receiptNo", $$v)
      },
      expression: "handover.receiptNo"
    }
  })], 1), _vm._v(" "), (!_vm.handover.receiptNo && _vm.isPridel == 'Pridel') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.receiptNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Amount Paid (In Rs)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ammountPaid",
      "name": "ammountPaid",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.ammountPaid),
      callback: function($$v) {
        _vm.$set(_vm.handover, "ammountPaid", $$v)
      },
      expression: "handover.ammountPaid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "date",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.handover, "paymentDate", $$v)
      },
      expression: "handover.paymentDate"
    }
  }), _vm._v(" "), (!_vm.handover.paymentDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.paymentDate))]) : _vm._e(), _vm._v(" "), (!_vm.handover.paymentDate && _vm.isPridel == 'Pridel') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.paymentDate))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("Payment Time")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "lang": "en",
      "type": "time",
      "format": "HH:mm",
      "placeholder": "Select Time",
      "minute-step": 1,
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    model: {
      value: (_vm.handover.paymentTime),
      callback: function($$v) {
        _vm.$set(_vm.handover, "paymentTime", $$v)
      },
      expression: "handover.paymentTime"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40",
      "md-flex-small": "100"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader223",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    on: {
      "click": _vm.addHandoverToRail
    }
  }, [_vm._v(_vm._s(_vm.handover.handoverTo == "HandOverToPort" ?
    "Save & Submit" :
    "Save & Proceed To Rail Out"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader223"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (
    (_vm.handover.handoverToRailId != '' &&
      _vm.handover.handoverTo != 'HandOverToPort') ||
    _vm.portType == 'Sea_Port'
  ) ? _c('div', {
    staticClass: "phone-viewport mt-4",
    attrs: {
      "id": "railOut"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    staticStyle: {
      "overflow": "visible",
      "background": "darkcyan !important"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.portType == "Sea_Port" ? " Gate-In at Terminal By Road" : "Rail Out "))]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "input": _vm.sameForAll
    },
    model: {
      value: (_vm.sameForAllSelected),
      callback: function($$v) {
        _vm.sameForAllSelected = $$v
      },
      expression: "sameForAllSelected"
    }
  })], 1), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container")]), _vm._v(" "), (_vm.portType != 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.portType == "Sea_Port" ?
    "TR Submission Mode" :
    "Train No.") + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              TR Submission\n                            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.portType == "Sea_Port" ? "Gate-In Type" : "Wagon  No.") + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.portType == "Sea_Port" ?
    "Gate-In Date" :
    "Train Departure Dt. & Time") + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.portType == "Sea_Port" ?
    "Date of Container Arrival at Port" :
    "Train Arrival Dt. & Time At Port") + "\n                            ")]), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              Vessel & Voyage Details\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('th', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                              Other Dates\n                            ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.containerNoList), function(item, indx) {
    return _c('tr', {
      key: indx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                              " + _vm._s(indx + 1) + " " + _vm._s(item.checked)), _c('br'), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
      attrs: {
        "value": "1",
        "unchecked-value": "0"
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }), _c('br'), _vm._v(" "), (item.checked == '1') ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "light"
      },
      on: {
        "click": function($event) {
          _vm.renderForAll(indx)
        }
      }
    }, [_vm._v("Replicate")]) : _vm._e()], 1), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                              " + _vm._s(item.ContainerNo ? item.ContainerNo : item.containerNo)), _c('br'), _c('small', [_vm._v(_vm._s(item.containerType))])]), _vm._v(" "), (_vm.portType != 'Sea_Port') ? _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.trainNo),
        callback: function($$v) {
          _vm.$set(item, "trainNo", $$v)
        },
        expression: "item.trainNo"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v(" TR Submission Mode")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.trModeList,
        "option-value": "tV",
        "option-text": "tT",
        "placeholder": "Select Mode "
      },
      model: {
        value: (item.trSubmitMode),
        callback: function($$v) {
          _vm.$set(item, "trSubmitMode", $$v)
        },
        expression: "item.trSubmitMode"
      }
    }), _vm._v(" "), (item.trSubmitMode == 'Online') ? _c('span', [_c('br'), _vm._v(" "), (item.trSubmitMode == 'Online') ? _c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Details",
        "id": "shippingBillNo",
        "name": "shippingBillNo"
      },
      model: {
        value: (item.trModeOnline),
        callback: function($$v) {
          _vm.$set(item, "trModeOnline", $$v)
        },
        expression: "item.trModeOnline"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(" TR Submission Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.trSubmitDate),
        callback: function($$v) {
          _vm.$set(item, "trSubmitDate", $$v)
        },
        expression: "item.trSubmitDate"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.gateInTypeList,
        "option-value": "gV",
        "option-text": "gT",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.gateInType),
        callback: function($$v) {
          _vm.$set(item, "gateInType", $$v)
        },
        expression: "item.gateInType"
      }
    })], 1) : _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.wagonNo),
        callback: function($$v) {
          _vm.$set(item, "wagonNo", $$v)
        },
        expression: "item.wagonNo"
      }
    })], 1), _vm._v(" "), _c('td', [(_vm.portType == 'Sea_Port') ? _c('date-picker', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a ",
        "minute-step": 1
      },
      model: {
        value: (item.gateInTypeDate),
        callback: function($$v) {
          _vm.$set(item, "gateInTypeDate", $$v)
        },
        expression: "item.gateInTypeDate"
      }
    }) : _c('date-picker', {
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a",
        "minute-step": 1,
        "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
          false :
          _vm.isPortLogin
      },
      model: {
        value: (item.trainDepartDate),
        callback: function($$v) {
          _vm.$set(item, "trainDepartDate", $$v)
        },
        expression: "item.trainDepartDate"
      }
    })], 1), _vm._v(" "), _c('td', [(_vm.portType == 'Sea_Port') ? _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.containerArivalAtPortDate),
        callback: function($$v) {
          _vm.$set(item, "containerArivalAtPortDate", $$v)
        },
        expression: "item.containerArivalAtPortDate"
      }
    }) : _c('date-picker', {
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD hh:mm a",
        "minute-step": 1,
        "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
          false :
          _vm.isPortLogin
      },
      model: {
        value: (item.trainArriveDate),
        callback: function($$v) {
          _vm.$set(item, "trainArriveDate", $$v)
        },
        expression: "item.trainArriveDate"
      }
    })], 1), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v("Vessel")]), _vm._v(" "), _c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.vesselName),
        callback: function($$v) {
          _vm.$set(item, "vesselName", $$v)
        },
        expression: "item.vesselName"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Voyage")]), _vm._v(" "), _c('b-form-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "formatter": _vm.capitalizeAll,
        "size": "sm"
      },
      model: {
        value: (item.vesselVoyage),
        callback: function($$v) {
          _vm.$set(item, "vesselVoyage", $$v)
        },
        expression: "item.vesselVoyage"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.portType == 'Sea_Port') ? _c('td', [_c('small', [_vm._v("Vessel Gate-Open Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.vesselEta),
        callback: function($$v) {
          _vm.$set(item, "vesselEta", $$v)
        },
        expression: "item.vesselEta"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Vessel ETD")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.vesselEtd),
        callback: function($$v) {
          _vm.$set(item, "vesselEtd", $$v)
        },
        expression: "item.vesselEtd"
      }
    }), _vm._v(" "), _c('small', [_vm._v("LEO Date")]), _vm._v(" "), _c('date-picker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "lang": "en",
        "type": "datetime",
        "format": "YYYY-MM-DD",
        "minute-step": 1
      },
      model: {
        value: (item.gateOutDate),
        callback: function($$v) {
          _vm.$set(item, "gateOutDate", $$v)
        },
        expression: "item.gateOutDate"
      }
    })], 1) : _vm._e()])
  })], 2)])]), _vm._v(" "), (
    _vm.getContainerNoData.length > 0 || _vm.railout.railOutTableId != ''
  ) ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader116",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.isPortLogin
    },
    on: {
      "click": function($event) {
        _vm.addRailOutTables('')
      }
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader116"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.railOutTableArrayList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }) : _vm._e()])], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopData",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop11212",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose11212
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb7b0c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/newCCHandoverToRail.vue
// module id = 2771
// module chunks = 0